/**
 * API Service for communication with the backend
 * This file handles HTTP requests to the backend
 */
import { logger } from '../utils/logger';

// Get the backend URL from environment variables or use a default
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Helper for making HTTP requests to the backend
export const fetchApi = async (endpoint, options = {}) => {
  // If endpoint already has /api prefix and BACKEND_URL also has it, don't duplicate
  const url = endpoint.startsWith('/api') || endpoint.startsWith('api') 
    ? `${BACKEND_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`
    : `${BACKEND_URL}/${endpoint}`;
  
  // Set default headers
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  // Add authentication token if available
  const token = localStorage.getItem('token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Prepare request
  const requestOptions = {
    ...options,
    headers
  };

  // Execute request
  try {
    const response = await fetch(url, requestOptions);
    
    // Handle non-2xx responses
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `API request failed with status ${response.status}`);
    }
    
    // Parse response
    return await response.json();
  } catch (error) {
    logger.error('API request error:', error);
    throw error;
  }
};
